import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  OTP_PENDING
} from "../actions/types";

const user = JSON.parse(localStorage.getItem("user"));
const initialState = user ? { isLoggedIn: true, user } : { isLoggedIn: false, user: null };

export default function auth(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case REGISTER_SUCCESS:
    case REGISTER_FAIL:
      return {
        ...state,
        isLoggedIn: false
      };

    case LOGIN_SUCCESS:
      localStorage.setItem("user", JSON.stringify(payload.user));
      return {
        ...state,
        isLoggedIn: true,
        user: payload.user
      };

    case OTP_PENDING:
      return {
        ...state,
        isLoggedIn: false,
        user: payload.user
      };

    case LOGIN_FAIL:
    case LOGOUT:
      localStorage.removeItem("user");
      return {
        ...state,
        isLoggedIn: false,
        user: null
      };

    default:
      return state;
  }
}
